import NotifyServiceDefault from "@/services/_bit/NotifyService";

class NotifyService extends NotifyServiceDefault {
  // You can redefine some part of default class here
}

export default new NotifyService();
